import React, { useState } from 'react'
import {
	AppBar,
	Toolbar,
	CssBaseline,
	useMediaQuery,
	alpha,
	Box,
	IconButton,
	Menu,
	MenuItem,
	Stack,
	Button,
	useTheme,
	Link,
} from '@mui/material'
import { makeStyles, styled } from '@mui/styles'
import { grey } from '@mui/material/colors'
// import Logo from '../static/epesiLogoWhite.png'
import NotificationMessage from './NotificationMessage'
import Footer from './Footer'
import { motion } from 'framer-motion'
import { MenuIcon } from 'lucide-react'

const useStyles = makeStyles(theme => ({
	footer: {
		backgroundColor: theme.palette.background.paper,
		padding: theme.spacing(6),
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: grey[50],
	},
	logo: {
		maxWidth: 160,
	},
	appBar: {
		borderBottom: '0.1px solid #F7FBFE',
		backgroundColor: theme.palette.primary.main,
		[`${theme.breakpoints.between('md', 'md')} and (orientation: landscape)`]: {
			backgroundColor: theme.palette.primary.main,
		},
		[theme.breakpoints.down('sm')]: {
			backgroundColor: theme.palette.primary.main,
		},
	},
}))

const StyledAppBar = styled(AppBar)(({ theme }) => ({
	backgroundColor: '#fff !important',
	backdropFilter: 'blur(10px)',
	maxHeight: '54px',
}))
const AnimatedButton = motion(Button)

const Logo = styled(motion.img)({
	maxHeight: '40px !important', // Default height
	cursor: 'pointer',
})

const AppLayout = ({ children }) => {
	const classes = useStyles()
	const theme = useTheme()

	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	const [anchorEl, setAnchorEl] = useState(null)

	const handleClose = () => {
		setAnchorEl(null)
	}
	const handleMenu = event => {
		setAnchorEl(event.currentTarget)
	}
	const logoVariants = {
		initial: { opacity: 0, x: -20 },
		animate: {
			opacity: 1,
			x: 0,
			transition: {
				duration: 0.6,
			},
		},
	}
	const buttonVariants = {
		hover: {
			scale: 1.05,
			transition: { duration: 0.2 },
		},
		tap: {
			scale: 0.95,
		},
	}

	return (
		<>
			<Box sx={{ backgroundColor: '#fff !important' }}>
				<StyledAppBar position="sticky" elevation={0}>
					<Toolbar sx={{ alignItems: 'center', maxHeight: '54px !important' }}>
						<Link
							href="/"
							sx={{
								display: 'inline-block',
								lineHeight: 0,
								maxHeight: '40px !important',
							}}
						>
							<Logo
								src="/images/epesiPrimary.png"
								alt="logo"
								variants={logoVariants}
							/>
						</Link>
						{/* {isMobile ? (
							<>
								<IconButton
									size="large"
									edge="end"
									color="primary"
									aria-label="menu"
									onClick={handleMenu}
								>
									<MenuIcon />
								</IconButton>
								<Menu
									id="menu-appbar"
									anchorEl={anchorEl}
									anchorOrigin={{
										vertical: 'top',
										horizontal: 'right',
									}}
									keepMounted
									transformOrigin={{
										vertical: 'top',
										horizontal: 'right',
									}}
									open={Boolean(anchorEl)}
									onClose={handleClose}
								>
									<MenuItem onClick={handleClose}>
										<AnimatedButton
											variant="text"
											color="primary"
											variants={buttonVariants}
											whileHover="hover"
											whileTap="tap"
											fullWidth
										>
											Login
										</AnimatedButton>
									</MenuItem>
									<MenuItem onClick={handleClose}>
										<AnimatedButton
											variant="text"
											color="primary"
											variants={buttonVariants}
											whileHover="hover"
											whileTap="tap"
											fullWidth
										>
											Create Account
										</AnimatedButton>
									</MenuItem>
								</Menu>
							</>
						) : (
							<Stack direction="row" spacing={2}>
								<AnimatedButton
									variant="outlined"
									color="secondary"
									variants={buttonVariants}
									whileHover="hover"
									whileTap="tap"
								>
									Login
								</AnimatedButton>
								<AnimatedButton
									variant="contained"
									color="primary"
									variants={buttonVariants}
									whileHover="hover"
									whileTap="tap"
								>
									Create Account
								</AnimatedButton>
							</Stack>
						)} */}
					</Toolbar>
				</StyledAppBar>
			</Box>

			<CssBaseline />
			<NotificationMessage />

			<Box
				sx={{
					overflow: 'auto',
				}}
			>
				{children}
			</Box>

			<Footer />
		</>
	)
}

export default AppLayout
